import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import PhoneMockup from "@/components/PhoneMockup";
import EventGalleryScreen from "@/components/mockups/EventGalleryScreen";

// Face-less Indonesia imagery
const BIRTHDAY =
  "https://images.unsplash.com/photo-1558636508-e0db3814bd1d?crop=entropy&cs=srgb&fm=jpg&w=940&q=85";
const BALI =
  "https://images.unsplash.com/photo-1531592937781-344ad608fabf?crop=entropy&cs=srgb&fm=jpg&w=940&q=85";

export default function NoCamera() {
  const { t } = useLang();
  return (
    <section
      data-testid="no-camera-section"
      className="bg-[#DDE7E4] py-24 lg:py-32"
    >
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-16 px-6 lg:grid-cols-2 lg:gap-24 lg:px-8">
        <div className="relative flex items-center justify-center gap-6">
          <PhoneMockup rotate={-5} className="z-10">
            <EventGalleryScreen
              title="Alya's Birthday"
              date="03.02.2026"
              photos={128}
              videos={22}
              contributors={34}
              image={BIRTHDAY}
            />
          </PhoneMockup>
          <PhoneMockup rotate={6} delay={0.15} className="-translate-y-8">
            <EventGalleryScreen
              title="Bali Adventure"
              date="21.09.2025"
              photos={487}
              videos={71}
              contributors={12}
              image={BALI}
            />
          </PhoneMockup>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="max-w-lg"
        >
          <h2 className="font-['Outfit'] text-4xl font-light leading-tight tracking-tight text-neutral-950 sm:text-5xl">
            No Camera <br />
            <span className="italic font-['Playfair_Display']">Can Capture</span> <br />
            Everything.
          </h2>
          <p className="mt-6 text-base leading-relaxed text-neutral-700 lg:text-lg">
            {t.noCamera.body}
          </p>
          <a
            href="#reach"
            data-testid="no-camera-cta"
            className="group mt-8 inline-flex items-center gap-2 text-sm uppercase tracking-[0.2em] text-neutral-950"
          >
            {t.noCamera.cta}
            <ArrowRight
              className="h-4 w-4 transition-transform group-hover:translate-x-1"
              strokeWidth={1.5}
            />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
